import http from '../utils/http'

export function getLableName (params) {
  return http.get('/customLabel/getLableName', params)
}

export function getStockList (params) {
  return http.get('/customLabel/getStockList', params)
}

export function addCustomStockPool (params) {
  return http.post('/customLabel/addCustomStockPool', params)
}

export function deletedCustomStockPool (params) {
  return http.post('/customLabel/deletedCustomStockPool', params)
}

export function updataStockList (params) {
  return http.post('/customLabel/updataStockList', params)
}



// WEBPACK FOOTER //
// ./src/api/customLabel.js